import { useBatchedGraphemeTileData } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.glyphs";
import { useMemo } from "react";
import {
  MorphemeGlyphTileGridView,
  type MorphemeGlyphTileGridViewProps,
} from "#morpheme-glyph-tile-grid-view";
import { normalizeGraphemeGlyph } from "#normalize-grapheme-glyph";

export type MorphemeGlyphTileListProps = Omit<
  MorphemeGlyphTileGridViewProps,
  "tileData"
>;

/**
 * A glyph grid over a whole grapheme list, with its tile data lifted in ONE stage read + ONE
 * pinyin-slice read for the entire set (see `useBatchedGraphemeTileData`). For a list that can be
 * hundreds long, reveal it a page at a time with `useRevealedMorphemeGlyphTileGrid` instead.
 */
export function MorphemeGlyphTileList({
  graphemeList,
  ...props
}: MorphemeGlyphTileListProps) {
  const graphemes = useMemo(
    () => graphemeList.map((glyph) => normalizeGraphemeGlyph(glyph).original),
    [graphemeList],
  );
  const tileData = useBatchedGraphemeTileData(graphemes);

  return (
    <MorphemeGlyphTileGridView {...props} graphemeList={graphemeList} tileData={tileData} />
  );
}
